// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list {
  max-height: 90vh;
  overflow-y: scroll;
  border-right: 1px solid;
  padding: 0px !important;
  margin: 0 !important;
  min-height: 86vh;
}`, "",{"version":3,"sources":["webpack://./src/app/home/test-rest-api/test-rest-api.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AACF","sourcesContent":[".list {\r\n  max-height: 90vh;\r\n  overflow-y: scroll;\r\n  border-right: 1px solid;\r\n  padding: 0px !important;\r\n  margin: 0 !important;\r\n  min-height: 86vh;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
